import { createStore } from "vuex";
import { auth } from "./auth.module";
import { filters } from "./filters.module";
import { i18n } from "./i18n.module";

const store = createStore({
  modules: {
    auth,
    filters,
    i18n,
  },
});

export default store;
